module.exports = __webpack_public_path__ + "71d367ef52565d050078254de6064b64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/crown-success.png
// module id = 1802
// module chunks = 1